import { customAxios } from '../../common/customAxios';

export const postSignOut = (): Promise<void> => {
  return customAxios.post('/auth/sign-out');
};
